import { useState } from 'react';
import { t, type MessageKey } from '../../../i18n';
import { Modal } from '../Modal';
import { NightIcon, type NightIconName } from './NightIcon';

/** The Long Night in six short steps: opens on the first visit, and from the hub at any time. */
const STEPS: readonly NightIconName[] = [
  'detour',
  'pawn',
  'brass',
  'superstition',
  'appraisal',
  'info',
];

export function NightGuide({ onClose }: { onClose: () => void }) {
  const [step, setStep] = useState(0);
  const last = STEPS.length - 1;
  const n = step + 1;
  return (
    <Modal
      title={t('nightGuide.title')}
      onClose={onClose}
      className="ln-guide"
      footer={
        <>
          <span
            className="ln-guide-dots"
            aria-label={t('campaignGuide.step', { n, total: STEPS.length })}
          >
            {STEPS.map((_, i) => (
              <span key={i} className={i === step ? 'is-on' : ''} />
            ))}
          </span>
          {step > 0 && (
            <button type="button" className="btn" onClick={() => setStep(step - 1)}>
              {t('campaignGuide.back')}
            </button>
          )}
          {step < last ? (
            <button
              type="button"
              className="btn btn-primary"
              data-autofocus
              onClick={() => setStep(step + 1)}
            >
              {t('campaignGuide.next')}
            </button>
          ) : (
            <button type="button" className="btn btn-primary" data-autofocus onClick={onClose}>
              {t('nightGuide.done')}
            </button>
          )}
        </>
      }
    >
      <div className="ln-guide-step" aria-live="polite">
        <span className="ln-guide-icon">
          <NightIcon name={STEPS[step]!} size={34} />
        </span>
        <h3>{t(`nightGuide.${n}.title` as MessageKey)}</h3>
        <p>{t(`nightGuide.${n}.text` as MessageKey)}</p>
      </div>
    </Modal>
  );
}
